export const ourStoryPageData = {
  seo: {
    title: 'Wedding App | Wedding AboutUs | Joy',
    content:
      'The best wedding app for you and your guests. Keep track of wedding details on the go, collect and share photos, make announcements, and more.',
  },
  allPostionsCta: '/careers',
  heroSection: {
    title: 'First comes love,<br />then comes Joy.',
  },
  ourStorySection: {
    title: 'Our Story',
    stories: [
      'Dorian, Kaiwalya, and I founded Joy to make wedding planning more intuitive, thoughtful, and personal.',
      'It all started when Dorian’s sister Amy was planning her wedding and we saw her struggle to find a wedding website that offered the personalization and attention to detail she was looking for. We built her a custom website to fit her style, and when her friends and wedding guests began asking us to create sites for them, we knew we were on to something.',
      'Soon we were meeting after our day jobs, spending our spare time designing a website that anyone could customize to feel like it was built just for them. In 2016 we officially founded Joy.',
      'We started with beautiful wedding websites, then developed powerful tools to modernize wedding planning, help couples stay organized, and create a seamless experience for couples and their guests.',
      'We’re constantly evolving and building new features, to give you a smarter way to plan your big day.',
    ],
    sincerely: 'Sincerely,',
    storyPerson: 'Vishal Joshi',
    designation: 'Co-founder and CEO',
  },
  featuredData: {
    title: 'As Featured In',
  },
  photoCollectionData: {
    altText: 'Joy Photo Collections',
    eyebrow: 'Word On The Street',
    title:
      '“Best overall wedding website: Joy.<br />Joy stands out for hitting the mark on detailed wedding websites powered by organizational and planning tools, all for free.”',
    body: '- Brides Magazine',
    photos: [
      'our-story/product-grid/product-squares-9.svg',
      'our-story/product-grid/product-rehearsal.svg',
      'our-story/product-grid/product-reg.png',
      'our-story/product-grid/product-website.png',
      'our-story/product-grid/product-gl.png',
      'our-story/product-grid/product-squares-5.png',
      'our-story/product-grid/product-send.svg',
      'our-story/product-grid/product-statuses.svg',
      'our-story/product-grid/product-squares-7.svg',
      'our-story/product-grid/product-plusone.png',
      'our-story/product-grid/product-map.svg',
    ],
  },
  joinOurTeam: {
    title: 'Join Our Team',
    body:
      'We’re always searching for qualified candidates to join our team! View our open job positions, or drop us a line at <a id="explore_email_link" target="_blank" href="mailto:recruiting@withjoy.com">recruiting@withjoy.com</a> for more information.',
    exploreCareers: 'Explore Careers',
  },
  footerSection: {
    title: 'Find Your Perfect Role',
    cta: 'Explore Careers',
  },
} as const;
